import GoogleMapReact from "google-map-react";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Card from "react-bootstrap/Card";
import CardDeck from "react-bootstrap/CardDeck";
import NumberFormat from "react-number-format";
import ReactTooltip from "react-tooltip";
import RingLoader from "react-spinners/RingLoader";
import NavbarComponent from "./Nav";
import CarouselComponent from "./CarouselComponent";
import DisplayCard from "./DisplayCard";
// import UserManualComponent from "./components/UserManualComponent";
import FooterComponent from "./FooterComponent";
import HospitalList from "./HospitalList";
import MainRoute from './Route'




function Map() {
  const style = {
   footer: {
   backgroundColor: "#00416d",
   fontFamily: "helveticaNeue, Arial, Helvetica, sans-serif",
   fontSize: "12px",
   margin: 0,
   lineHeight: "20px",
   color: "#00416d",
   boxSizing: "border-box",
   borderColor: "#00416d",
   justifyContent : "space-around", 
   backgroundColor: "white",
   fontWeight: "normal",
   backgroundColor: "#00416d",
   color: "white",
   textAlign: "center",
   padding: "5px 10px",
   minHeight: "50px",
   alignItems: "center",
   display: "grid",
   gridGap: "10px"
  }
  };

  const [latest, setLatest] = useState([]);
  const [results, setResults] = useState([]);
  const [searchCountries, setSearchCountries] = useState("");
  const [loading, setLoading] = useState(true);
  const [darkTheme, setDarkTheme] = useState(false);

  const date = new Date(parseInt(latest.updated));
  const lastUpdated = date.toString();

  useEffect(() => {
    axios
      .all([
        axios.get("https://corona.lmao.ninja/v2/all"),
        axios.get("https://corona.lmao.ninja/v2/countries"),
      ])
      .then((responseArr) => {
        setLatest(responseArr[0].data);
        setResults(responseArr[1].data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const countriesLocations = results.map((data, i) => {
    return (
      <div
        lat={data.countryInfo.lat}
        lng={data.countryInfo.long}
        style={{
          color: "red",
          backgroundColor: "#FFF",
          height: "25px",
          width: "35px",
          textAlign: "center",
          borderRadius: "50%",
        }}>
        {data.cases}
        <img height="10px" src={data.countryInfo.flag} />
        <br />
      </div>
    );
  });


  const filterCountries = results.filter((item) => {
    return searchCountries !== ""
      ? item.country.toLowerCase().includes(searchCountries.toLowerCase())
      : item;
  });

  const countries = filterCountries.map((data, i) => {
    return (
      <Card
        key={i}
        bg={"light"}
        text={"dark"}
        className="text-center"
        style={{ margin: "10px" }}>
        <Card.Img variant="top" src={data.countryInfo.flag} />
        <Card.Body>
          <Card.Title>{data.country}</Card.Title>
          <Card.Text>Cases {data.cases}</Card.Text>
          <Card.Text>Deaths {data.deaths}</Card.Text>
          <Card.Text>Recovered {data.recovered}</Card.Text>
          <Card.Text>Today's cases {data.todayCases}</Card.Text>
          <Card.Text>Today's deaths {data.todayDeaths}</Card.Text>
          <Card.Text>Active {data.active}</Card.Text>
          <Card.Text>Critical {data.critical}</Card.Text>
        </Card.Body>
      </Card>
    );
  });

  var queries = [
    {
      columns: 2,
      query: "min-width: 500px",
    },
    {
      columns: 3,
      query: "min-width: 1000px",
    },
  ];

  return (
    <div className="App">
      <NavbarComponent />
      <CarouselComponent />
    <HospitalList></HospitalList>

      <div
        style={
          {
            // backgroundColor: "white",
            // color: "white",
          }
        }>
        <br />
        {/* <CarouselComponent /> */}
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <RingLoader size={50} color={"blue"} loading={loading} />
        </div>
        <br />
        <h2
          data-tip="Last modified date: 16/05/2020 - v2.2"
          style={{ textAlign: "center" }}>
          COVID-19 Live Now
        </h2>
        <ReactTooltip effect="solid" />
        <br />
      </div>

      <CardDeck>
        <Card
          bg="secondary"
          text="white"
          className="text-center"
          style={{ margin: "10px", justifyContent : "space-around"  }}>
          <Card.Body>
            <Card.Title>Cases</Card.Title>
            {/* <Card.Text>{latest.cases}</Card.Text> */}
            <NumberFormat
              value={latest.cases}
              displayType={"text"}
              thousandSeparator={true}
              style={{ fontSize: "30px" }}
            />
          </Card.Body>
          <Card.Footer>
            <small>Last updated {lastUpdated}</small>
          </Card.Footer>
        </Card>
        <Card
          bg="danger"
          text={"white"}
          className="text-center"
          style={{ margin: "10px" }}>
          <Card.Body>
            <Card.Title>Deaths</Card.Title>
            <Card.Text>
              {" "}
              <NumberFormat
                value={latest.deaths}
                displayType={"text"}
                thousandSeparator={true}
                style={{ fontSize: "30px" }}
              />
            </Card.Text>
          </Card.Body>
          <Card.Footer>
            <small>Last updated {lastUpdated}</small>
          </Card.Footer>
        </Card>
        <Card
          bg="success"
          text={"white"}
          className="text-center"
          style={{ margin: "10px" }}>
          <Card.Body>
            <Card.Title>Recovered</Card.Title>
            <Card.Text>
              {" "}
              <NumberFormat
                value={latest.recovered}
                displayType={"text"}
                thousandSeparator={true}
                style={{ fontSize: "30px" }}
              />
            </Card.Text>
          </Card.Body>
          <Card.Footer>
            <small>Last updated {lastUpdated}</small>
          </Card.Footer>
        </Card>
      </CardDeck>

      <div style={{ height: "100vh", width: "100%" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyDICcJJakqF9y0qhrALXFY4xiIYvReQSys" }}
          defaultCenter={{ lat: 20, lng: 77 }}
          defaultZoom={4}>
          {countriesLocations}
        </GoogleMapReact>
      </div>

      <br />

      <DisplayCard />

      <br />
      <hr></hr>
      <br />

      {/* <UserManualComponent /> */}

      <br />
      <hr></hr>
      <br />

      {/* <FooterComponent /> */}
      <footer
       style={style.footer}
       className="relative one-column xs-three-columns"
       >
       <div>Vaccine Tracker</div>
       <div>COVID Tracker</div>
       <div>Bed Tracker</div>
       <div></div>
       <div className="made"><image src="{logo}"/>Made by team WEWIN</div>
       </footer>
    </div>
  );
}

export default Map;
